export default __webpack_public_path__ + "static/ensino-fundamental-hover-71b6442f41630e20c6a243502f87a8a1.svg";